import { render, staticRenderFns } from "./AnoFiscalCard.vue?vue&type=template&id=5fb8cdef&lang=html&"
import script from "./AnoFiscalCard.vue?vue&type=script&lang=js&"
export * from "./AnoFiscalCard.vue?vue&type=script&lang=js&"
import style0 from "./AnoFiscalCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/ano-fiscal/AnoFiscalCard.vue
// module id = 1042
// module chunks = 28